import React, {Component} from "react";
import { observer } from "mobx-react";
import OrderMenuListItemView from "./OrderMenuListItemView";
import SettingDefaultDeliveryItemView from "../../../../setting/sub/SettingDefaultDeliveryItemView";
import OrderListMenuSideDetailItemView from "./OrderMenuSideDetailItemView";

@observer
class OrderMenuSideDetailView extends Component {

    constructor(props){
        super(props);
        this.state = {isToggleOn:false};
        this.fn_layerView = this.fn_layerView.bind(this);
        this.fn_soldOutLayer = this.props.fn_soldOutLayer.bind(this);
    }

    fn_layerView(){
        this.setState(layerState =>({
            isToggleOn: !layerState.isToggleOn
        }));
    }

    render() {

        const { rootStore } = this.props;
        const menuDetail = rootStore.menuStore.getMenuDetail;

        return (

            <div className="wrap_side_menu">
                <h5>사이드 메뉴</h5>
                {
                    (menuDetail.sdsList[0].connProdNm != null) ?
                        <dl className={this.state.isToggleOn ? 'info on' : 'info'} onClick={this.fn_layerView}>
                            <dt>
                                <button><strong>연결메뉴</strong><span>상품 수정사항이 다음 메뉴에 동시에 적용됩니다.</span>
                                </button>
                            </dt>
                            <dd>{menuDetail.sdsList[0].connProdNm}
                            </dd>
                        </dl>
                        : null
                }
                {
                    menuDetail.sdsList.map((obj, index)=>(
                        <OrderListMenuSideDetailItemView index={index} rootStore={rootStore} obj={obj} fn_soldOutLayer={this.fn_soldOutLayer} key={index} />
                    ))
                }
            </div>
        );
    }
}

export default OrderMenuSideDetailView;